import *  as service from '../services/PianoTechPianoServices';

export const FETCH_PIANOTECHPIANO_LIST_STARTED = 'FETCH_PIANOTECHPIANO_LIST_STARTED';
export const FETCH_PIANOTECHPIANO_LIST_SUCCEEDED = 'FETCH_PIANOTECHPIANO_LIST_SUCCEEDED';
export const FETCH_PIANOTECHPIANO_LIST_FAILED = 'FETCH_PIANOTECHPIANO_LIST_FAILED';
export const FIND_PIANOTECHPIANO_STARTED = 'FIND_PIANOTECHPIANO_STARTED';
export const FIND_PIANOTECHPIANO_SUCCEEDED = 'FIND_PIANOTECHPIANO_SUCCEEDED';
export const FIND_PIANOTECHPIANO_FAILED = 'FIND_PIANOTECHPIANO_FAILED';
export const SAVE_PIANOTECHPIANO_STARTED = 'SAVE_PIANOTECHPIANO_STARTED';
export const SAVE_PIANOTECHPIANO_SUCCEEDED = 'SAVE_PIANOTECHPIANO_SUCCEEDED';
export const SAVE_PIANOTECHPIANO_FAILED = 'SAVE_PIANOTECHPIANO_FAILED';
export const RETURN_TO_PIANOTECHPIANO_LIST = 'RETURN_TO_PIANOTECHPIANO_LIST';
export const SWITCH_EDIT_TYPE = 'SWITCH_EDIT_TYPE';
export const PIANOTECHPIANO_MODIFIED = 'PIANOTECHPIANO_MODIFIED';
export const PIANOTECHPIANO_VALIDATE = 'PIANOTECHPIANO_VALIDATE';
export const FETCH_PIANOTECHPIANO_LIST_FOR_COMPANY_STARTED = 'FETCH_PIANOTECHPIANO_LIST_FOR_COMPANY_STARTED';
export const FETCH_PIANOTECHPIANO_LIST_FOR_COMPANY_SUCCEEDED = 'FETCH_PIANOTECHPIANO_LIST_FOR_COMPANY_SUCCEEDED';
export const FETCH_PIANOTECHPIANO_LIST_FOR_COMPANY_FAILED = 'FETCH_PIANOTECHPIANO_LIST_FOR_COMPANY_FAILED';
export const PIANOTECHPIANO_UPDATE_PIANO_LIST = 'PIANOTECHPIANO_UPDATE_PIANO_LIST';

function fetchPianoTechPianoListSucceeded(response) {
    const jsonResponse = JSON.parse(JSON.stringify(response.data));
    const pianoTechPianoList = jsonResponse.pianoTechPianoList;

    const errorMessage = jsonResponse.errorDescription;

    if (errorMessage) {
        return {
            type: FETCH_PIANOTECHPIANO_LIST_FAILED,
            message: errorMessage,
        }
    }

    return {
        type: FETCH_PIANOTECHPIANO_LIST_SUCCEEDED,
        pianoTechPianoList
    }
}

function fetchPianoTechPianoListFailed(response) {
    const errorMessage = 'Failed to retrieve PianoTechPiano list.';

    return {
        type: FETCH_PIANOTECHPIANO_LIST_FAILED,
        message: errorMessage
    }
}

export function fetchPianoTechPianoList() {
    return dispatch => {

        dispatch({
            type: FETCH_PIANOTECHPIANO_LIST_STARTED
        });

        service
            .getPianoTechPianoList()
            .then(resp => {
                dispatch(fetchPianoTechPianoListSucceeded(resp))
            })
            .catch(error => {
                dispatch(fetchPianoTechPianoListFailed(error))
            });
    }
}

function findPianoTechPianoSucceeded(response) {
    const jsonResponse = JSON.parse(JSON.stringify(response.data));
    const pianoTechPiano = jsonResponse.pianoTechPiano;
    const originalPianoTechPiano = Object.assign({}, pianoTechPiano);

    const errorMessage = jsonResponse.errorDescription;

    if (errorMessage) {
        return {
            type: FIND_PIANOTECHPIANO_FAILED,
            message: errorMessage,
        }
    }

    return {
        type: FIND_PIANOTECHPIANO_SUCCEEDED,
        pianoTechPiano,
        originalPianoTechPiano,
    }
}

function findPianoTechPianoFailed(response) {
    const errorMessage = 'Failed to find PianoTechPiano.';

    return {
        type: FIND_PIANOTECHPIANO_FAILED,
        message: errorMessage
    }
}

export function findPianoTechPiano(pianoId) {
    return dispatch => {

        service
            .findPianoTechPiano(pianoId)
            .then(resp => {
                dispatch(findPianoTechPianoSucceeded(resp))
            })
            .catch(error => {
                dispatch(findPianoTechPianoFailed(error))
            });
    }
}

function savePianoTechPianoSucceeded(response, pianoTechPiano) {
    const jsonResponse = JSON.parse(JSON.stringify(response.data));
    const message = 'PianoTechPiano ' + pianoTechPiano.maintenanceType + ' Successful.';
    let updatedPianoTechPiano = pianoTechPiano;

    const errorMessage = jsonResponse.errorDescription;

    if (errorMessage) {
        return {
            type: SAVE_PIANOTECHPIANO_FAILED,
            message: errorMessage,
        }
    }

    if (jsonResponse.pianoTechPiano) {
        updatedPianoTechPiano = jsonResponse.pianoTechPiano;
    }

    console.log('pianoTechPiano.updatePianoListForCustomer: ' + updatedPianoTechPiano.updatePianoListForCustomer);
    if (pianoTechPiano.updatePianoListForCustomer) {
        // dispatch PIANOTECHPIANO_UPDATE_PIANO_LIST and SAVE_PIANOTECHPIANO_SUCCEEDED
        updatedPianoTechPiano.updatePianoListForCustomer = false;
        updatedPianoTechPiano.complete = true;
        var pianoTechPianoList = jsonResponse.pianoTechPianoList;

        return {
            type: PIANOTECHPIANO_UPDATE_PIANO_LIST,
            pianoTechPianoList: pianoTechPianoList,
            pianoTechPiano: updatedPianoTechPiano,
            message,
        }
    }

    return {
        type: SAVE_PIANOTECHPIANO_SUCCEEDED,
        pianoTechPiano: updatedPianoTechPiano,
        message,
    }
}

function savePianoTechPianoFailed(response) {
    const errorMessage = 'Action failed: ' + response.message;

    return {
        type: SAVE_PIANOTECHPIANO_FAILED,
        message: errorMessage
    }
}

export function savePianoTechPiano(pianoTechPiano) {
    return dispatch => {

        service
            .savePianoTechPiano(pianoTechPiano)
            .then(resp => {
                dispatch(savePianoTechPianoSucceeded(resp, pianoTechPiano))
            })
            .catch(error => {
                dispatch(savePianoTechPianoFailed(error))
            });
    }
}

export function getPianosForCompany(companyId) {
    return dispatch => {
        dispatch({
            type: FETCH_PIANOTECHPIANO_LIST_FOR_COMPANY_STARTED
        });

        service
            .getPianoTechPianoListForCompany(companyId)
            .then(resp => {
                dispatch(fetchPianoTechPianoListForCompanySucceeded(resp))
            })
            .catch(error => {
                dispatch(fetchPianoTechPianoListForCompanyFailed(error))
            });
    }
}

function fetchPianoTechPianoListForCompanySucceeded(response) {
    const jsonResponse = JSON.parse(JSON.stringify(response.data));

    return {
        type: FETCH_PIANOTECHPIANO_LIST_FOR_COMPANY_SUCCEEDED,
        pianoTechPianoList: jsonResponse.pianoTechPianoList,
    }
}

function fetchPianoTechPianoListForCompanyFailed(response) {
    const errorMessage = 'Failed to fetch PianoTechPiano list for company.';

    return {
        type: FETCH_PIANOTECHPIANO_LIST_FOR_COMPANY_FAILED,
        message: errorMessage
    }
}


